import * as React from 'react';
import { FeaturedProducts } from '@grandvisionhq/products';
import { useIntl } from '@grandvisionhq/state';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachPageName } from '../../hooks/use-bloomreach-page-name.js';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';

const CmsRecommendedProducts = ({ meta  })=>{
    const { getLabel  } = useIntl();
    const pageName = useBloomreachPageName();
    return /*#__PURE__*/ React.createElement(FeaturedProducts, {
        skus: meta.recommendedProducts || [],
        title: getLabel('blog.content.recommendedProducts.title'),
        renderLocation: pageName
    });
};
var CmsRecommendedProducts$1 = compose(withBreakpointVisibility, withEditableContent, withBloomreachData, withAnchor)(CmsRecommendedProducts);

export { CmsRecommendedProducts, CmsRecommendedProducts$1 as default };
//# sourceMappingURL=RecommendedProducts.js.map
